import axios from 'axios'
import { FRONTEND_RELEASE } from './releases'
import { BASE_URL } from './baseUrl'

function logAppInfo (release, frontendRelease, userType) {
  const outputText = '%cWelcome to %ceDoatap%c!%c\n\nRelease (frontend/backend): %s / %s\nUser type: %s\n\n'
  const titleStyle = 'padding-top: 0.5em; font-size: 1.5em;'
  const logoStyle = 'color: #cbf1fc; font-size: 1.5em; font-weight: bold; background-color: #002e69; padding: 0.5em 1em;'
  const defaultStyle = ''
  release.then(version => {
    console.log(outputText, titleStyle, logoStyle, titleStyle, defaultStyle, frontendRelease, version, userType)
  })
}

async function getBackendRelease () {
  try {
    const response = await axios.get(`${BASE_URL}/version`)
    return Object.keys(response.data.data.history)[0]
  } catch (error) {
    console.log('Error fetching app version: ', error)
    return 'Unknown'
  }
}

// Debug info
const USER_TYPE = 'Internal'

// Log application info to console
logAppInfo(getBackendRelease(), FRONTEND_RELEASE, USER_TYPE)

// Global constants and variables
const DEBUG = false
const PRODUCTION_DOMAIN = 'doatap.gr'
let STAGING_ENV = false
const OVERDUE_PERIOD = 60 // days
const OVERDUE_MESSAGE = `Προσοχή! Η αίτηση επανεξέτασης έχει υποβληθεί μετά το πέρας των ${OVERDUE_PERIOD} ημερών από τη παραλαβή της απόφασης`

if (process.env.NODE_ENV === 'production' || window.location.hostname.includes(PRODUCTION_DOMAIN)) {
  STAGING_ENV = false
}

export default {
  BASE_URL,
  getBackendRelease,
  USER_TYPE,
  FRONTEND_RELEASE,
  DEBUG,
  STAGING_ENV,
  OVERDUE_PERIOD,
  OVERDUE_MESSAGE
}



// WEBPACK FOOTER //
// ./src/config.js